import { SVGProps } from "react"

interface CategoryStepIconProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const CategoryStepIcon = (props: CategoryStepIconProps) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.666687"
      width="50"
      height="50"
      rx="25"
      fill={props.isActive ? "#2768A3" : "#ABB7C2"}
      fill-opacity={props.isActive ? "1" : "0.1"}
    />
    <path
      d="M31.0467 23.3794V26.6094C31.0467 29.2994 29.9667 30.3794 27.2767 30.3794H24.0467C21.3567 30.3794 20.2767 29.2994 20.2767 26.6094V23.3794C20.2767 20.6894 21.3567 19.6094 24.0467 19.6094H27.2767C29.9767 19.6194 31.0467 20.6894 31.0467 23.3794Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.6667 18.77V22C35.6667 24.69 34.5867 25.77 31.8967 25.77H31.0467V23.39C31.0467 20.7 29.9667 19.62 27.2767 19.62H24.8967V18.77C24.8967 16.08 25.9767 15 28.6667 15H31.8967C34.5867 15 35.6667 16.08 35.6667 18.77Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6667 31.2305V28.0005C15.6667 25.3105 16.7467 24.2305 19.4367 24.2305H20.2867V26.6104C20.2867 29.3004 21.3667 30.3805 24.0567 30.3805H26.4367V31.2305C26.4367 33.9205 25.3567 35.0005 22.6667 35.0005H19.4367C16.7467 35.0005 15.6667 33.9205 15.6667 31.2305Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default CategoryStepIcon
